<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
	export default {
		components: {
		},
		created() {
		}
	}
</script>

<style lang="less">
	
</style>